module.exports = __webpack_public_path__ + "img/bulletins.3b12d224.svg";